import script from "./AppEditorButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppEditorButton.vue?vue&type=script&lang=ts&setup=true"

import "./AppEditorButton.vue?vue&type=style&index=0&id=c587983e&lang=css"

const __exports__ = script;

export default __exports__